import { Pipe, PipeTransform } from '@angular/core';
import { Category } from '@tekman/onmat/service/onmat';

@Pipe({
  name: 'isResource',
})
export class isResourcePipe implements PipeTransform {
  transform(categoryId: string): boolean {
    return categoryId === Category.RECURSOS;
  }
}

@Pipe({
  name: 'isExercise',
})
export class isExercisePipe implements PipeTransform {
  transform(categoryId: string): boolean {
    if (!categoryId) return false;
    return categoryId === Category.EJERCICIOS;
  }
}
